module.exports = __webpack_public_path__ + "static/media/allie.3123014e.png";